import { Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { useAuth } from "src/core/hooks/useAuth";
import { recapService } from "src/core/services/priceConfiguratorServices/recapService";
import { RecapSectionTypeEnum } from "src/enums";
import { RoutingExplosionRecapTable } from "src/modules/PriceConfiguratorManager/components/DataSectionManager/sections/Recap/components/RecapDataSection/components/RoutingExplosionRecapContent/components/RoutingExplosionRecapTable/RoutingExplosionRecapTable";
import { currentPriceConfiguratorState } from "src/recoil/atoms";
import { RecapSectionData } from "src/types/priceConfigurator";

type Props = { reloadData?: boolean };

const { Title } = Typography;

export const RoutingExplosionRecapContent: React.FC<Props> = (props: Props) => {
  const { reloadData } = props;

  const [tableLoading, setTableLoading] = useState(false);

  const { t } = useTranslation();
  const [data, setData] = useState<RecapSectionData>();

  const { accessToken, success, authLoaded } = useAuth();

  const currentPriceConfigurator = useRecoilValue(
    currentPriceConfiguratorState
  );

  useEffect(() => {
    (async () => {
      if (authLoaded && success && !reloadData) {
        setTableLoading(true);

        const response = await recapService.getRecapDataByType(
          accessToken,
          currentPriceConfigurator.id,
          currentPriceConfigurator.modelNumber,
          RecapSectionTypeEnum.ROUTINGSEXPLOSION
        );

        setData(response);

        setTableLoading(false);
      }
    })();
  }, [
    accessToken,
    authLoaded,
    currentPriceConfigurator.id,
    currentPriceConfigurator.modelNumber,
    reloadData,
    success,
  ]);

  return (
    <Space className="full-width-space" align="baseline" direction="vertical">
      <Title level={4}>{t("label.routingsExplosion")}</Title>
      <Title level={5} style={{ marginTop: 35 }}>
        {t("label.byOperation")}
      </Title>
      <RoutingExplosionRecapTable
        byMainLayer={false}
        dataItems={data?.routingOperationExplosionData?.data ?? []}
        thresholds={data?.routingOperationExplosionData?.thresholds}
        loading={tableLoading}
        tableHoverTotalsContentId="recapRoutingExplosionByOperationHoverTotals"
      />
      <Title level={5} style={{ marginTop: 35 }}>
        {t("label.byMainLayer")}
      </Title>
      <RoutingExplosionRecapTable
        byMainLayer={true}
        dataItems={data?.routingMainLayerExplosionData ?? []}
        loading={tableLoading}
      />
    </Space>
  );
};
